import { SelectListItem } from 'components/select/select-list-item';
import styled, { css } from 'styled-components';

const PopoverContentStyles = css`
    z-index: ${props => props.theme.zIndex.PentOutermost};
    margin: 0;
    border-radius: ${props => props.theme.radius.large};
    box-shadow: ${props => props.theme.shadows.popover};
    border: none;
    background-color: white;
`;

const ListItemsContainer = styled.ul<{
    triggerRef: HTMLDivElement | HTMLButtonElement | null;
    autoWidth?: boolean;
    headless?: boolean;
}>`
    padding: 0;
    list-style-type: none;

    ${props =>
        !props.headless &&
        css`
            ${PopoverContentStyles};
            border-radius: ${props => props.theme.radius.default};
            padding: 0.2rem;

            & > ${SelectListItem}:first-of-type {
                border-top-left-radius: ${props => props.theme.radius.default};
                border-top-right-radius: ${props => props.theme.radius.default};
            }

            & > ${SelectListItem}:last-of-type {
                border-bottom-right-radius: ${props => props.theme.radius.default};
                border-bottom-left-radius: ${props => props.theme.radius.default};
            }
        `};


    ${props => {
        return (
            props.triggerRef &&
            !props.autoWidth &&
            css`
                width: ${props.triggerRef.offsetWidth}px;
            `
        );
    }}
}`;

export { ListItemsContainer };
